import { getConfig } from '../core/config';
import { storeProof } from '../core/state';
import { createWidgetSession } from '../core/session';
import { VerenaIframe } from '../auth/iframe';
import type { VerenaProof } from '../core/config';

export class VerenaInline {
  private verenaIframe: VerenaIframe | null = null;

  mount(container: Element | string): void {
    const el = typeof container === 'string'
      ? document.querySelector(container)
      : container;

    if (!el) {
      throw new Error('Verena: container element not found');
    }

    const config = getConfig();

    createWidgetSession().then(({ sessionId }) => {
      this.verenaIframe = new VerenaIframe({
        apiUrl: config.apiUrl!,
        sessionId,
        theme: config.theme || 'light',
        onVerified: (proof: VerenaProof) => {
          storeProof(proof);
          config.onVerified?.(proof);
        },
        onError: (error: Error) => {
          config.onError?.(error);
        },
      });

      const frame = this.verenaIframe.create();
      el.appendChild(frame);
    }).catch((error) => {
      config.onError?.(error);
    });
  }

  destroy(): void {
    this.verenaIframe?.destroy();
    this.verenaIframe = null;
  }
}
